import _ from 'lodash';
import type { Reducer, Effect } from 'umi';
import {
  fetchAnalytics,
  fetchComboOrderAnalytics,
  fetchCostAnalytics,
  fetchDashboardAnalytics,
  fetchHotelOrderAnalytics,
  fetchTourOrderAnalytics,
  fetchVisaOrderAnalytics,
} from './services';
import type { ConnectState } from '@/models/connect';
import type {
  AnalyticsStateType,
  FetchAnalyticsResp,
  FetchTourOrderAnalyticsResp,
} from './analytics.data';

export type AnalyticsModelType = {
  namespace: string;
  state: AnalyticsStateType;
  effects: {
    fetchAnalytics: Effect;
    fetchCostAnalytics: Effect;
    fetchDashboardAnalytics: Effect;
    fetchTourOrderAnalytics: Effect;
    fetchVisaOrderAnalytics: Effect;
    fetchHotelOrderAnalytics: Effect;
    fetchComboOrderAnalytics: Effect;
  };
  reducers: {
    fetchAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchCostAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchDashboardAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchTourOrderAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchVisaOrderAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchHotelOrderAnalyticsSuccess: Reducer<AnalyticsStateType>;
    fetchComboOrderAnalyticsSuccess: Reducer<AnalyticsStateType>;
  };
};

const Model: AnalyticsModelType = {
  namespace: 'analytics',

  state: {
    query: {},
  },

  effects: {
    *fetchAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchAnalyticsResp = yield call(fetchAnalytics, _.omitBy(query, _.isNil));

      yield put({
        type: 'fetchAnalyticsSuccess',
        payload: {
          costAnalytics: response.costAnalytics,
          orderAnalytics: response.orderAnalytics,
          revenueAnalytics: response.revenueAnalytics,
          query,
        },
      });
    },
    *fetchDashboardAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchAnalyticsResp = yield call(
        fetchDashboardAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchDashboardAnalyticsSuccess',
        payload: {
          totalPartner: response.totalPartner,
          totalTourQT: response.totalTourQT,
          totalTourND: response.totalTourND,
          totalPlace: response.totalPlace,
          totalUser: response.totalUser,
          totalOrder: response.totalOrder,
          realRevenue: response.realRevenue,
          revenueSystem: response.revenueSystem,
          totalPartnerPaid: response.totalPartnerPaid,
          totalPrice: response.totalPrice,
          tourSellTop: response.tourSellTop,
          totalQuotation: response.totalQuotation,
          avgTimeQuotation: response.avgTimeQuotation,
          totalReservation: response.totalReservation,
          orderAnalytics: response.orderAnalytics,
          revenueAnalytics: response.revenueAnalytics,
          quotationAnalytics: response.quotationAnalytics,
          query,
        },
      });
    },
    *fetchTourOrderAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchTourOrderAnalyticsResp = yield call(
        fetchTourOrderAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchTourOrderAnalyticsSuccess',
        payload: {
          totalOrder: response.totalOrder,
          totalPrice: response.totalPrice,
          totalPricePaid: response.totalPricePaid,
          totalOrderPaid: response.totalOrderPaid,
          totalOrderSuccess: response.totalOrderSuccess,
          query,
        },
      });
    },
    *fetchVisaOrderAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchTourOrderAnalyticsResp = yield call(
        fetchVisaOrderAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchTourOrderAnalyticsSuccess',
        payload: {
          totalOrder: response.totalOrder,
          totalPrice: response.totalPrice,
          totalPricePaid: response.totalPricePaid,
          totalOrderPaid: response.totalOrderPaid,
          totalOrderSuccess: response.totalOrderSuccess,
          query,
        },
      });
    },
    *fetchHotelOrderAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchTourOrderAnalyticsResp = yield call(
        fetchHotelOrderAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchTourOrderAnalyticsSuccess',
        payload: {
          totalOrder: response.totalOrder,
          totalPrice: response.totalPrice,
          totalPricePaid: response.totalPricePaid,
          totalOrderPaid: response.totalOrderPaid,
          totalOrderSuccess: response.totalOrderSuccess,
          query,
        },
      });
    },
    *fetchComboOrderAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchTourOrderAnalyticsResp = yield call(
        fetchComboOrderAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchTourOrderAnalyticsSuccess',
        payload: {
          totalOrder: response.totalOrder,
          totalPrice: response.totalPrice,
          totalPricePaid: response.totalPricePaid,
          totalOrderPaid: response.totalOrderPaid,
          totalOrderSuccess: response.totalOrderSuccess,
          query,
        },
      });
    },
    *fetchCostAnalytics({ payload: updatedParams }, { call, put, select }) {
      // @ts-ignore
      const currentQuery = yield select((state: ConnectState) => state.analytics.query);

      const query = { ...currentQuery, ...updatedParams };

      const response: FetchTourOrderAnalyticsResp = yield call(
        fetchCostAnalytics,
        _.omitBy(query, _.isNil),
      );

      yield put({
        type: 'fetchCostAnalyticsSuccess',
        payload: {
          totalPrice: response.totalPrice,
          totalPricePaid: response.totalPricePaid,
          totalDiscount: response.totalDiscount,
          totalRemain: response.totalRemain,
          query,
        },
      });
    },
  },
  reducers: {
    fetchAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchDashboardAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchTourOrderAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchVisaOrderAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchHotelOrderAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchComboOrderAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    fetchCostAnalyticsSuccess(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
